import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import { Route, Switch } from "react-router-dom";

import { NavTabsContainer } from "altus-ui-components";

import {
  settingsRoutes,
  employeeRoutes,
  subcontractorRoutes,
} from "app/routes";

import { filterValidRoutesForUser } from "utils/app.util";
import { getCurrentUserFromState } from "app/app.selectors";

class ApplicationTabs extends PureComponent {
  render() {
    const { currentUser } = this.props;

    const filterValidRoutesForCurrentUser = filterValidRoutesForUser(
      currentUser,
    );

    /* We want to add a tab for the OverviewContainer, but since
     * the route is hidden we need to add it manually.
     */
    const settingsTabRoutes = [
      { path: "/settings", breadcrumb: "Overview" },
      ...filterValidRoutesForCurrentUser(settingsRoutes[0].routes),
    ];

    return (
      <Switch>
        <Route
          path="/settings"
          render={() => (
            <NavTabsContainer
              routes={filterValidRoutesForCurrentUser(settingsTabRoutes)}
            />
          )}
        />
        <Route
          path="/employee/:employeeCardId"
          render={() => (
            <NavTabsContainer
              routes={filterValidRoutesForCurrentUser(employeeRoutes[0].routes)}
            />
          )}
        />
        <Route
          path="/sub-contractor/:employeeCardId"
          render={() => (
            <NavTabsContainer
              routes={filterValidRoutesForCurrentUser(
                subcontractorRoutes[0].routes,
              )}
            />
          )}
        />
      </Switch>
    );
  }
}

export default compose(
  connect(state => ({
    currentUser: getCurrentUserFromState(state),
  })),
)(ApplicationTabs);
